import { signalingTranscriptionSpokenLanguageChanged } from 'features/transcripts/actions';
import { call } from 'redux-saga/effects';
import { announceTranscriptionLanguageSaga } from 'features/transcripts/sagas/announceTranscriptionLanguageSaga';

export function* onSpokenLanguageChangedSaga(
  action: ReturnType<typeof signalingTranscriptionSpokenLanguageChanged>
) {
  const { data } = action.payload;

  if (!data.applyToAll) {
    return;
  }

  yield call(announceTranscriptionLanguageSaga, 'session');
}
